export enum DateFormats {
  DayOfMonth = 'd',
  LocalizedDate = 'P',
  MonthAbbrev = 'MMM',
  DayOfMonthOrdinal = 'do',
  MonthAbbrevDay = 'MMM d',
  HourMinuteAmPm = 'h:mm a',
  MonthDayYearSlashShortYear = 'M/d/yy',
  MonthDayYearLongText = 'MMMM d, yyyy',
  YearMonthDayDashStorage = 'yyyy-MM-dd',
  MonthDayYearSlashDisplay = 'MM/dd/yyyy',
  MonthDayYearLongDisplay = 'MMMM do, yyyy',
  MonthDayYearSlashDisplayShort = 'M/d/yyyy',
  MonthDayYearSlashTimeDisplay = 'M/d/yyyy p',
  MonthDayYearSlashShortYearPadded = 'MM/dd/yy',
  HourMinuteAmPmMonthDayYearShortYear = 'h:mma M/d/yy',
  WeekdayDashMonthDayYearSlashDisplay = 'eeee - MM/dd/yyyy',
  WeekdayMonthDayYearLongTimeDisplay = 'EEEE, MMMM do yyyy, h:mm:ss a',
}
